<template>
    <li :class="{ expanded: component.showDetail }" class="list-item">
        <header :aria-expanded="component.showDetail" class="columns no-outline tablet-column">
            <div class="agenda-date-bg absolute hide-for-small"></div>
            <div class="row">
                <div class="small-20 medium-3 large-3 agenda-date columns collapsed">
                    <div class="section-full-height">
                        <time class="small">{{ entry.date }}</time><br />
                        <time class="small">{{ entry.timeFrom }}</time>
                        - <time class="small">{{ entry.timeTo }}</time>
                    </div>
                </div>
                <h2 class="item-title toggle-header small-20 medium-11 large-11 columns collapsed">
                    <a @click.prevent="toggleShowDetail" class="accordion-heading-link underline" tabindex="0">
                        {{ entry.roomName }}
                        <i class="icon-toggle"></i>
                    </a>
                    <span class="information">
                        {{ entry.address }} in {{ entry.city }}
                        {{ getTranslation('camp_raum_OnFloor') }} {{ entry.floor }}
                    </span>
                </h2>
                <div class="information small-20 medium-5 large-5 small columns collapsed large-offset-1">
                    <p class="collapsed important">
                        <strong><a :href="bookingUrl + entry.bookingLinkQuery">{{ getTranslation('camp_raum_BookDo') }}</a></strong>
                    </p>
                </div>
            </div>
        </header>

        <div v-show="component.showDetail" class="additional-content tablet-column columns" style="display: block;">
            <div class="row">
                <div class="description small-20 large-11 large-offset-3 columns">
                    <p class="richtext"></p>
                </div>
                <div class="more-details small-20 medium-11 large-11 large-offset-3 columns">
                    <table class="detail-table">
                        <tbody>
                            <tr>
                                <th>{{ getTranslation('camp_edu_RaumType') }}</th>
                                <td class="no-bottom-padding">{{ entry.roomType }}</td>
                            </tr>
                            <tr v-if="entry.equipment">
                                <th>{{ getTranslation('camp_raum_Equipment') }}</th>
                                <td class="no-bottom-padding">{{ entry.equipment }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="small-20 large-20 columns">
                    <div class="mobile-full-width">
                        <p class="section-close collapsed">
                            <button @click.prevent="toggleShowDetail" class="button-close" data-section-close="">{{ getTranslation('camp_close') }}</button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>
<script>
    export default {
        name: "ResultEntry",
        props: {
            entry: null,
            translations: null,
            bookingUrl: null
        },
        data() {
            return {
                component: {
                    showDetail: null
                }
            }
        },
        methods: {
            getTranslation(key) {
                return this.translations[key];
            },
            toggleShowDetail() {
                this.component.showDetail = !this.component.showDetail;
            }
        }
    }
</script>